import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastType } from 'src/app/enum/toast.enum';
import { Toast } from 'src/app/models/toast.model';

const TOAST_DURATION_MS: number = 4000;
const TOAST_TRANSITION_MS: number = 300;

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private nextId: number = 0;
  private readonly toastsSubject: BehaviorSubject<Toast[]> = new BehaviorSubject<Toast[]>([]);
  public readonly toasts$: Observable<Toast[]> = this.toastsSubject.asObservable();

  public success(message: string): void {
    this.show(ToastType.SUCCESS, message);
  }

  public error(message: string): void {
    this.show(ToastType.ERROR, message);
  }

  public dismiss(id: number): void {
    const toasts: Toast[] = this.toastsSubject.value;
    const toast: Toast | undefined = toasts.find((t: Toast) => t.id === id);
    if (!toast || toast.removing) {
      return;
    }
    this.toastsSubject.next(toasts.map((t: Toast) => (t.id === id ? { ...t, removing: true } : t)));
    setTimeout(() => {
      this.toastsSubject.next(this.toastsSubject.value.filter((t: Toast) => t.id !== id));
    }, TOAST_TRANSITION_MS);
  }

  private show(type: ToastType, message: string): void {
    const toast: Toast = { id: this.nextId++, type, message, removing: false };
    this.toastsSubject.next([...this.toastsSubject.value, toast]);
    setTimeout(() => this.dismiss(toast.id), TOAST_DURATION_MS);
  }
}
